export { default as AuthenticationRoutes } from "./Authentication.routes";
export { default as LegacyAuthenticationRoutes } from "./LegacyAuthentication.routes";
